enum SizeExtendedEnum {
  X1 = "1x",
  X2 = "2x",
  X3 = "3x",
  X4 = "4x",
  X5 = "5x"
}
export default SizeExtendedEnum;
